import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormDropDown } from "../../components/form/dropdown";
import { FormTextAreaField } from "../../components/form/text-area";
import { FormDocumentField } from "../../components/form/document-field";
import { FormDateField } from "../../components/form/date";
import { FormLocationPickerField } from "../../components/map/map-selector";
import { api } from "../../redux/apis/api";

const CreateCustomer = ({ popup = false, closePopUp = () => {} }) => {
  const naviagte = useNavigate();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [userList, setuserList] = useState([]);

  const initialValues = {
    name: "",
    address: "",
    state_id: "",
    city_id: "",
    location: {
      lat: "",
      lng: "",
    },
    visiting_card_photo: "",
    outside_place_photo: "",
    type_of_client: "",
    contact_name: "",
    contact_number: "",
    price_agreed_upon: "",
    status: "",
    type_of_billing: "",
    billing_name: "",
    billing_address: "",
    billing_city: "",
    billing_state: "",
    billing_pincode: "",
    pan_number: "",
    gst_number: "",
    last_order_on: "",
    customer_type: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/customer/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");

        if (!popup) {
          naviagte(`/customer/list`);
        } else {
          closePopUp();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
    fetchUserDropDownData();
  }, []);

  const typeOfClientOptions = [
    {
      label: "small",
      value: "small",
    },
    {
      label: "large",
      value: "large",
    },
    {
      label: "medium",
      value: "medium",
    },
  ];

  const statusOptions = [
    {
      label: "active",
      value: "active",
    },
    {
      label: "inactive",
      value: "inactive",
    },
    {
      label: "closed",
      value: "closed",
    },
    {
      label: "lost",
      value: "lost",
    },
  ];

  const typeOfBillingOptions = [
    {
      label: "half",
      value: "half",
    },
    {
      label: "full",
      value: "full",
    },
    {
      label: "none",
      value: "none",
    },
  ];

  const customerTypesOptions = [
    {
      label: "Individual",
      value: "individual",
    },
    {
      label: "Shop",
      value: "shop",
    },
    {
      label: "Distributor",
      value: "distributor",
    },
    {
      label: "Tile layer",
      value: "tile_layer",
    },
    {
      label: "Contractor",
      value: "contractor",
    },
    {
      label: "Industry",
      value: "industry",
    },
  ];

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                customer - Create
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => {
                    if (!popup) {
                      naviagte("/customer/list");
                    } else {
                      closePopUp();
                    }
                  }}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Create
                </button>
              </div>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormTextField
                  name={"name"}
                  label={"name"}
                  placeholder={`Enter customer name`}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="state_id"
                  label="state"
                  options={stateList}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="city_id"
                  label="city"
                  options={citiesList}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"address"}
                  label={"address"}
                  placeholder={`Enter company address`}
                  rows={3}
                />
              </div>
              <div className="my-4">
                <FormDocumentField
                  name={"visiting_card_photo"}
                  label={"visiting card photo"}
                />
              </div>
              <div className="my-4">
                <FormDocumentField
                  name={"outside_place_photo"}
                  label={"outside place photo"}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"contact_name"}
                  label={"contact name"}
                  placeholder={`Enter contact name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"contact_number"}
                  label={"contact number"}
                  placeholder={`Enter contact number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"price_agreed_upon"}
                  label={"price agreed upon"}
                  placeholder={`Enter price agreed upon`}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="type_of_client"
                  label="type of client"
                  options={typeOfClientOptions}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="status"
                  label="status"
                  options={statusOptions}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="type_of_billing"
                  label="type of billing"
                  options={typeOfBillingOptions}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="customer_type"
                  label="customer type"
                  options={customerTypesOptions}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"billing_name"}
                  label={"billing name"}
                  placeholder={`Enter billing name`}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"billing_address"}
                  label={"billing address"}
                  placeholder={`Enter billing address`}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="billing_state"
                  label="billing state"
                  options={stateList}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="billing_city"
                  label="billing city"
                  options={citiesList}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"billing_pincode"}
                  label={"billing pincode"}
                  placeholder={`Enter billing pincode`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"pan_number"}
                  label={"pan number"}
                  placeholder={`Enter pan number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"gst_number"}
                  label={"gst number"}
                  placeholder={`Enter gst number`}
                />
              </div>
              <div className="my-4">
                <FormDateField name={"last_order_on"} label={"last order on"} />
              </div>

              <div>
                <FormLocationPickerField name={"location"} label={"location"} />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateCustomer;
